<div class="container text-center pt-5">
  <h1>Anmeldung REGP</h1>
  <p>
    Dies ist die REGP Eventübersichtsseite. Hier können Events und deren Teilnehmer bearbeitet und abgerechnet werden.
  </p>

  <div class="row" *ngIf="!sessionService.session.sessionId && !sessionService.mfaChallenge && !sessionService.mfaSetupChallenge">
    <div class="col-lg-2 d-none d-lg-block"></div>
    <div class="col-12 col-lg-8 anmeldeDiv p-3 rounded shadow-lg">
      <h4>Anmelden</h4>
      <form>

        <input class="m-1  form-control" [(ngModel)]="username" name="username" type="text" placeholder="Benutzername">
        <input class="m-1  form-control" [(ngModel)]="password" name="password" type="password" placeholder="Passwort">
        <input class="m-1 btn pcButton " type="submit" value="Login" (click)="login()">
        <input *ngIf="passkeySupported" class="m-1 btn pcButton " type="button" value="Mit Passkey anmelden" (click)="loginWithPasskey()">
        <input class="m-1 btn scButton " type="button" value="Registrieren" routerLink="/registration">
        <input class="m-1 btn scButton " type="button" value="Login vergessen" data-toggle="collapse" data-target="#recoveryInput" aria-expanded="false" aria-controls="recoveryInput">

      </form>
    </div>
    <div class="col-lg-2 d-none d-lg-block"></div>
  </div>

  <!-- Zweiter Login-Schritt (MFA) -->
  <div class="row" *ngIf="!sessionService.session.sessionId && sessionService.mfaChallenge">
    <div class="col-lg-2 d-none d-lg-block"></div>
    <div class="col-12 col-lg-8 anmeldeDiv p-3 rounded shadow-lg">
      <h4>Code eingeben</h4>
      <p *ngIf="sessionService.mfaChallenge.methode === 'MAIL'">
        Ein Anmeldecode wurde an Ihre hinterlegte E-Mail-Adresse gesendet. Der Code ist 10 Minuten gültig.
      </p>
      <p *ngIf="sessionService.mfaChallenge.methode === 'TOTP'">
        Bitte geben Sie den Code aus Ihrer Authenticator-App ein.
      </p>
      <form>
        <input class="m-1 form-control" [(ngModel)]="mfaCode" name="mfaCode" type="text" inputmode="numeric" autocomplete="one-time-code" placeholder="6-stelliger Code">
        <input class="m-1 btn pcButton " type="submit" value="Bestätigen" (click)="verifyMfa()">
        <input class="m-1 btn scButton " type="button" value="Abbrechen" (click)="cancelMfa()">
      </form>
    </div>
    <div class="col-lg-2 d-none d-lg-block"></div>
  </div>

  <!-- MFA-Pflicht: zweiten Faktor beim Login einrichten -->
  <div class="row" *ngIf="!sessionService.session.sessionId && sessionService.mfaSetupChallenge">
    <div class="col-lg-2 d-none d-lg-block"></div>
    <div class="col-12 col-lg-8 anmeldeDiv p-3 rounded shadow-lg">
      <h4>Zweiten Faktor einrichten</h4>
      <p>
        Für die Anmeldung ist ein zweiter Faktor verpflichtend. Bitte wählen Sie, wie Sie sich künftig zusätzlich zum Passwort bestätigen möchten.
      </p>
      <form>
        <select class="m-1 form-control" [(ngModel)]="setupMethode" name="setupMethode" (ngModelChange)="onSetupMethodeChange()">
          <option value="MAIL">Code per E-Mail</option>
          <option value="TOTP">Authenticator-App (TOTP)</option>
        </select>
        <p *ngIf="setupMethode === 'MAIL'" class="small m-1">
          Bei jeder Anmeldung wird ein Code an Ihre hinterlegte E-Mail-Adresse gesendet.
        </p>
        <div *ngIf="setupMethode === 'TOTP' && totpSetup" class="m-1">
          <img [src]="totpSetup.qrDataUrl" alt="QR-Code für die Authenticator-App" class="img-fluid"/>
          <p class="small">
            Scannen Sie den QR-Code mit Ihrer Authenticator-App (z.B. Google Authenticator, Aegis) und bestätigen Sie mit dem angezeigten Code.<br>
            Alternativ das Secret manuell eingeben: <code>{{totpSetup.secret}}</code>
          </p>
          <input class="form-control" [(ngModel)]="setupCode" name="setupCode" type="text" inputmode="numeric" autocomplete="one-time-code" placeholder="6-stelliger Code">
        </div>
        <input class="m-1 btn pcButton " type="submit" value="Einrichten und anmelden" (click)="completeMfaSetup()" [disabled]="setupMethode === 'TOTP' && !totpSetup">
        <input *ngIf="sessionService.mfaSetupChallenge.remainingPostpones > 0" class="m-1 btn scButton " type="button"
               [value]="'Später einrichten (noch ' + sessionService.mfaSetupChallenge.remainingPostpones + 'x möglich)'" (click)="postponeMfaSetup()">
        <input class="m-1 btn scButton " type="button" value="Abbrechen" (click)="cancelMfaSetup()">
      </form>
      <p *ngIf="sessionService.mfaSetupChallenge.remainingPostpones === 0" class="small mt-2">
        Die Einrichtung kann nicht weiter aufgeschoben werden.
      </p>
    </div>
    <div class="col-lg-2 d-none d-lg-block"></div>
  </div>
  <div class="mt-3 collapse row" id="recoveryInput">
    <div class="col-lg-2 d-none d-lg-block"></div>
    <div class="col-12 col-lg-8 anmeldeDiv p-3 rounded shadow-lg">
      <h4>Passwort wiederherstellen</h4>
      <input class="m-1 form-control" [(ngModel)]="email" name="email" type="text" placeholder="E-Mail">
      <button class="m-1 btn pcButton " type="button" (click)="sendPasswordRecoveryMail()">Passwort zurücksetzen <i *ngIf="mailIsSending" class="fas fa-circle-notch fa-spin"></i></button>
      <button class="m-1 btn pcButton " type="button" (click)="sendUsernameRecoveryMail()">Benutzername vergessen <i *ngIf="mailIsSending" class="fas fa-circle-notch fa-spin"></i></button>
    </div>
    <div class="col-lg-2 d-none d-lg-block"></div>
  </div>
</div>


